import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";
import { supabase } from "../../config/supabaseClient";
import { Button } from "antd";

const WelcomeConfetti = ({ username, firstName }: any) => {
  const [showMessage, setShowMessage] = useState(true);

  const handleClose = async () => {
    // setShowConfetti(false);
    // setShowMessage(false);
    // Update the is_first_redirect flag to false
    try {
      await supabase
        .from("user")
        .update({ is_first_redirect: false })
        .eq("username", username);
    } catch (error) {
      console.error("Error updating first redirect:", error);
    }
  };

  useEffect(() => {
    handleClose();
  }, []);

  if (!showMessage) return null;

  const handleBookStrategyCall = () => {
    window.open("https://calendly.com/d/cn26-xr5-srh/strategy-call", "_blank");
  };

  const handleWatchTutorials = () => {
    window.open("https://www.searchbubble.com/tutorials", "_blank");
  };

  return (
    <div>
      {/* <div style={{
        background: 'rgba(255, 255, 255, 0.95)',
        padding: '40px 60px',
        borderRadius: '20px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        textAlign: 'center',
        maxWidth: '600px',
        animation: 'fadeInUp 0.6s ease-out',
        position: 'relative',
        pointerEvents: 'auto'
      }}> */}
      {/* <button
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666',
            padding: '5px',
            lineHeight: '1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
        >
          ×
        </button> */}
      <div style={{ marginBottom: "24px" }}>
        <h1
          style={{
            margin: "0 0 12px 0",
            color: "#fff",
            fontSize: "24px",
            fontWeight: "bold",
            lineHeight: "1.2",
            textAlign: "center",
          }}
        >
          Onboarding Complete!
        </h1>
      </div>

      <div
        style={{
          color: "#e6e7eb",
          fontSize: "16px",
          lineHeight: "1.6",
          textAlign: "center",
        }}
      >
        <p style={{ margin: "0", opacity: "0.9" }}>
          Our team is now syncing your content and building your dashboard. This
          process takes up to <b>48 hours</b>, and you’ll get an email as soon as your
          link in bio is ready to go. 
          </p><br/>
          <p>In the meantime, you’re
          welcome to book a strategy call or watch a quick tutorial — but no
          action is needed right now. </p><br/>
          <p> <b>We’ve got it from here. We’re
          excited to show you the power of an auto-updating link in bio!</b></p>
        
        <br/>
        {/* <br />
        <p><strong>We’ve got it from here. We’re excited to show you the power of an auto-updating link in bio!</strong></p>
        <br /> */}
      </div>
      <div
        style={{ display: "flex", justifyContent: "space-between", gap: "6px" }}
      >
        <button className="next-button" onClick={()=>handleBookStrategyCall()}>Book a Strategy Call</button>
        <button className="next-button" onClick={()=>handleWatchTutorials()}>Watch Tutorials</button>
      </div>
      {/* </div> */}
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
};

export default WelcomeConfetti;
